import { getSafeAreaPaddings, getTheme } from "@clipboard-health/ui-theme";
import { isDefined } from "@clipboard-health/util-ts";
import { CircularProgress, Stack, ThemeProvider } from "@mui/material";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { useHistory } from "react-router-dom";

import { StickyScrollPageHeader } from "../redesign/components/StickyScrollPageHeader";
import { useWorkerNegotiationShifts } from "./api/useWorkerNegotiationShifts";
import { RateNegotiationListContent } from "./RateNegotiationListContent";

export function RateNegotiationListPage() {
  const history = useHistory();
  const { data: workerNegotiationShifts, isLoading } = useWorkerNegotiationShifts();

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper
        sx={(theme) => ({
          backgroundColor: theme.palette.common.white,
          ...getSafeAreaPaddings({
            bottom: true,
            fallbackBottom: theme.spacing(4),
          }),
        })}
      >
        <StickyScrollPageHeader
          title="Shifts in Negotiation"
          headerVariant="tertiary"
          onClickBack={() => {
            history.goBack();
          }}
        />
        {isLoading && (
          <Stack sx={{ alignItems: "center", mt: 10 }}>
            <CircularProgress />
          </Stack>
        )}
        {isDefined(workerNegotiationShifts) && (
          <RateNegotiationListContent workerNegotiationShifts={workerNegotiationShifts} />
        )}
      </PageWrapper>
    </ThemeProvider>
  );
}
